'use client'

import {facebookLink, linkedInLink, twitterLink} from 'util/share'

import {useApp} from 'AppContext'
import {Icon} from 'assets/icon'
import {BlockFC} from 'blocks/block'
import {Theme} from 'layout/theme'
import {usePathname} from 'next/navigation'
import React from 'react'
import {DPShareBlock} from 'types/DPTypes'
import {useTranslation} from 'util/i18'
import {fromModule} from 'util/styler/Styler'
import css from './share.module.scss'

const styles = fromModule(css)

export const Share: BlockFC<DPShareBlock> = () => {
	const {node} = useApp()
	const t = useTranslation()
	const links = ['facebook', 'twitter', 'linkedin']

	if (!links || links.length == 0) return null

	return (
		<div className={styles.share()}>
			<Theme.Container>
				<p className={styles.share.text()}>{t.share}</p>
				<div className={styles.share.icons()}>
					{links.map((link, i) => (
						<Sharelink
							key={i}
							type={link}
							title={node?.title}
							description={
								node?._type !== 'eu_project' ? node?.meta?.description : null
							}
						/>
					))}
				</div>
			</Theme.Container>
		</div>
	)
}

const Sharelink: React.FC<{
	type: string
	description?: string
	title?: string
}> = (data) => {
	const pathname = usePathname()
	const t = useTranslation()
	const {type} = data
	return (
		<a
			{...sharePlatform(type, pathname)}
			target="_blank"
			className={styles.link.mod(type)()}
			title={t.social[type]}
			aria-label={t.share + ' ' + t.social[type]}
		>
			<span className={styles.link.icon()}>
				<SociallinkIcon type={type} />
			</span>
		</a>
	)
}

const SociallinkIcon: React.FC<{type: string}> = ({type}) => {
	switch (type) {
		case 'facebook':
			return <Icon icon="Facebook" />
		case 'linkedin':
			return <Icon icon="LinkedIn" />
		case 'twitter':
			return <Icon icon="X" />
		default:
			return null
	}
}

function sharePlatform(type, href) {
	if (!type) return null

	const fullHref = process.env.NEXT_PUBLIC_WEBSITE_URL + href

	switch (type) {
		case 'facebook':
			return facebookLink(fullHref)
		case 'twitter':
			return twitterLink('', fullHref)
		case 'linkedin':
			return linkedInLink(fullHref)
		default:
			return null
	}
}
